var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0378 2.7201C19.0731 1.75945 17.5097 1.76004 16.5457 2.72142L9.0903 10.1583C8.49401 10.753 8.14344 11.5492 8.10796 12.3891L8.00182 14.9018C7.9535 16.046 8.87116 16.9998 10.0203 16.9999L12.4924 17C13.4 17 14.2692 16.6349 14.9029 15.9874L22.2984 8.40804C23.2425 7.44344 23.2326 5.90152 22.2761 4.94907L20.0378 2.7201ZM17.4985 3.67018C17.9366 3.23319 18.6473 3.23293 19.0858 3.66958L21.3241 5.89856C21.7588 6.33149 21.7634 7.03236 21.3342 7.47082L19.8489 8.98837L16.0046 5.16008L17.4985 3.67018ZM15.0526 6.10956L10.043 11.1071C9.68526 11.4639 9.47492 11.9416 9.45363 12.4456L9.3475 14.9583C9.33139 15.3397 9.63728 15.6576 10.0203 15.6576L12.4924 15.6577C13.037 15.6578 13.5585 15.4387 13.9388 15.0502L18.9084 9.94931L15.0526 6.10956Z",
    stroke: "none",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 13C21.75 12.5858 21.4142 12.25 21 12.25C20.5858 12.25 20.25 12.5858 20.25 13H21.75ZM12 4.75C12.4142 4.75 12.75 4.41421 12.75 4C12.75 3.58579 12.4142 3.25 12 3.25V4.75ZM16 21.25H8V22.75H16V21.25ZM3.75 17V9H2.25V17H3.75ZM20.25 13V17H21.75V13H20.25ZM8 4.75H12V3.25H8V4.75ZM8 21.25C5.65279 21.25 3.75 19.3472 3.75 17H2.25C2.25 20.1756 4.82436 22.75 8 22.75V21.25ZM16 22.75C19.1756 22.75 21.75 20.1756 21.75 17H20.25C20.25 19.3472 18.3472 21.25 16 21.25V22.75ZM3.75 9C3.75 6.65279 5.65279 4.75 8 4.75V3.25C4.82436 3.25 2.25 5.82436 2.25 9H3.75Z",
    stroke: "none",
    fill: "current"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit-2.aa9487bdfe42eb9b7053d767cf09e860.svg";